import React, {useState} from "react";
import {IChipsDataTabs, IChipsGallery} from "./interfaces";

interface IChipsGalleryProps {
    chipsGalleryProps: IChipsGallery,
}

const Chips = (props?:IChipsGalleryProps) =>{
    const chipsGalleryProps = props?.chipsGalleryProps;
    const dataTabsLength = chipsGalleryProps && chipsGalleryProps.dataTabs && chipsGalleryProps.dataTabs.length ? chipsGalleryProps.dataTabs.length : 0;
    const [selectedTab, setSelectedTab] = useState(dataTabsLength > 0 && chipsGalleryProps?.dataTabs ? chipsGalleryProps.dataTabs[0].dataTabId : '');

    const tabClick = (tab:IChipsDataTabs) => {
        let $elm = document.getElementById(tab.dataTabId);
        if ($elm){
            if ($elm.classList.contains('hidden')){
                $elm.classList.remove('hidden');                
            }
            let $otherElms = document.querySelectorAll(`[data-type-tab = ${chipsGalleryProps?.dataTabType ? chipsGalleryProps.dataTabType : 'none'}]`);
            if ($otherElms){
                for (let i=0;i<$otherElms.length;i++){
                    let $curElm = $otherElms[i];
                    if ($curElm.id !== $elm.id){
                        $curElm.classList.add('hidden');
                    }
                }
            }
            setSelectedTab($elm.id);
        }
    }

    return (
        <>
            {
                chipsGalleryProps?.dataTabs &&
                <div className="mt-8 carousel waves-box-sm px-5 md:px-0 mx-auto">
                    <div className="arr-left py-1 flex items-center h-full z-50" style={{display:'none'}}>
                        <div className="py-2 bg-white flex justify-center items-center h-full w-full">&lt;</div>
                    </div>
                    <ul data-carusel="mobile" className="flex flex-wrap carousel-slides justify-center" style={{left:'0'}}>
                        {
                            chipsGalleryProps.dataTabs.map((dataTab, i) => {
                                let classEx = (selectedTab === dataTab.dataTabId) ? "bg-blue-200 text-white" : "bg-gray-150 text-gray-700";
                                let classLast = i === dataTabsLength ? 'mr-8' : '';
                                return (
                                    <li key={dataTab.dataTabId + '-' + i} className={`p-1 carousel-row ${classLast}`}><button className={`flex ${classEx} text-sm  py-4 px-6 mr-2 rounded no-underline`} onClick={() => tabClick(dataTab)}>{dataTab.dataTabName}</button></li>
                                )
                            })
                        }
                    </ul>
                </div>
            }
        </>
        )
    }
export default Chips;